import React, { useEffect, useState } from "react";
import MyTable from "../../../components/CustomTable";
import { BiEdit } from "react-icons/bi";
import { MdOutlineDeleteForever } from "react-icons/md";
import CustomModal from "../../../components/CustomModal";
import EditCodeBookOptions from "./EditCodeBookOptions";
import search from "../../../images/search.svg";
import {
  deletecodebook,
  getAllCodeBookOptions,
} from "../../../Api/services/code-BookService";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../../utils/hooks/useDebounce";
import { useLocation, useParams } from "react-router-dom";
import SearchInput from "../../../components/CustomSearchInput";
import DeleteButton from "../../../components/DeleteButton";
import { withNamespaces } from "react-i18next";

const CodeBookOptions = ({ t }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  //intial state
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortBy, setSortBy] = useState("created_at"); // Default sort by 'name' column
  const [pageIndex, setPageIndex] = useState(1); // Track current page index
  const [pageSize, setPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [openLanguageModel, setOpenLanguageModel] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  // check if the codebook is leave type
  const searchParams = new URLSearchParams(location.search);
  const title = searchParams.get("title");
  const isCodeBookLeaveType = title?.toLowerCase() === "leave type";
  //codebook listing data
  const { codeBookOptionsData, loading } = useSelector(
    (state) => state?.codebook
  );
  //for search input
  const debouncedSearchText = useDebounce(searchText, 2000); //Adjust the delay as needed

  //open language modal for adding
  const openAddLanguageModal = () => {
    setIsEditMode(false);
    setSelectedLanguage(null);
    setOpenLanguageModel(true);
  };

  //open language modal for editing
  const openEditLanguageModal = (language) => {
    setIsEditMode(true);
    setSelectedLanguage(language);
    setOpenLanguageModel(true);
  };

  //close model
  const closeLanguageModal = () => {
    setOpenLanguageModel(false);
  };

  //sort direction
  const handleSortChange = (columnId) => {
    if (sortBy === columnId) {
      // Toggle the sort direction if the same column is clicked
      setSortDirection((prevDirection) =>
        prevDirection === "asc" ? "desc" : "asc"
      );
    } else {
      // Set to ascending if a different column is clicked
      setSortBy(columnId);
      setSortDirection("asc");
    }
  };

  // Function to handle page change
  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

  // Function to handle page size change
  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  //delete codebook options
  const deletecodeoptionsbook = async (deleteid) => {
    const result = await dispatch(deletecodebook(deleteid));
    if (result?.payload && result.payload.success === true) {
      //after delele api call
      const data = {
        page_size: pageSize,
        order_by: sortBy,
        order_type: sortDirection,
        page: pageIndex,
        search_text: searchText,
      };
      dispatch(getAllCodeBookOptions({ id: id, data: data }));
    }
  };

  //table columns
  const columns = React.useMemo(() => {
    const baseCols = [
      {
        Header: t("code_books.tables.Title"),
        accessor: "option",
        key: "option",
      },
      {
        Header: " ",
        disableSortBy: true,
        Cell: ({ row }) => (
          // best css positioning for action buttons
          <div className="flex justify-end content-center w-full text-end">
            <button onClick={() => openEditLanguageModal(row.original)}>
              <BiEdit className="text-lg" />
            </button>
            <DeleteButton
              onDelete={() => deletecodeoptionsbook(row.original.id)}
            />
          </div>
        ),
      },
    ];

    // Add additional columns if the codebook is a leave type
    if (isCodeBookLeaveType) {
      baseCols.splice(
        1,
        0,

        {
          Header: t("code_books.tables.annual_leave"),
          accessor: "annual_leave",
          key: "annual_leave",
          Cell: ({ cell }) => (
            <div className="">{`${
              cell.value ? t("misc.yes") : t("misc.no")
            }`}</div>
          ),
        },
        {
          Header: t("code_books.tables.off_site"),
          accessor: "off_site",
          key: "off_site",
          Cell: ({ cell }) => (
            <div className="">{`${
              cell.value ? t("misc.yes") : t("misc.no")
            }`}</div>
          ),
        }
      );
    }

    return baseCols;
  }, [isCodeBookLeaveType]);

  //api call
  useEffect(() => {
    const data = {
      page_size: pageSize,
      order_by: sortBy,
      order_type: sortDirection,
      page: pageIndex,
      search_text: searchText,
    };
    dispatch(getAllCodeBookOptions({ id: id, data: data }));
  }, [sortBy, sortDirection, pageIndex, pageSize, searchText, dispatch]);

  return (
    <div className="p-5">
      <div className="border-2 border-white rounded-[14px] px-[22px] py-5 bg-gradient-to-r from-[#ffffff5e] to-[#ffffffcc] mb-6">
        <div className="flex justify-between items-center">
          <SearchInput
            name="search"
            label={t("code_books.tables.search_lable")}
            placeholder={t("code_books.tables.search_placeholder")}
            id="search"
            // onChange={(e) => {
            //   console.log(e, "e");
            //   setSearchText(e.target.value);
            // }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                setSearchText(e.target.value);
              }
            }}
            onBlur={(e) => {
              setSearchText(e.target.value);
            }}
          />
          <div className=" flex">
            <button
              onClick={openAddLanguageModal}
              className=" py-2 px-[14px] bg-primary_orange text-white rounded-[14px] flex items-center font-pop font-semibold text-xs mr-5"
            >
              {" "}
              {t("code_books.tables.Add_options")}
            </button>
            {/* <button className=" py-2 px-[14px] text-primary_orange border border-primary_orange rounded-[14px] flex items-center font-pop font-semibold text-xs">
              {" "}
              Import Data
            </button> */}
          </div>
        </div>
      </div>
      <MyTable
        columns={columns}
        data={codeBookOptionsData?.data?.codebook_option || []}
        tableTitle={title}
        totalCount={codeBookOptionsData?.data?.total_count || 0}
        initialPageIndex={pageIndex}
        initialPageSize={pageSize}
        sortDirection={sortDirection}
        sortBy={sortBy}
        onSortChange={handleSortChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        loading={loading}
      />
      <CustomModal
        isOpen={openLanguageModel}
        onClose={closeLanguageModal}
        title={isEditMode ? `Edit ${title}` : `Add ${title} `}
      >
        <EditCodeBookOptions
          onClose={closeLanguageModal}
          isEditMode={isEditMode}
          codeBookOption={selectedLanguage}
        />
      </CustomModal>
    </div>
  );
};

export default withNamespaces()(CodeBookOptions);
